import { render, staticRenderFns } from "./tabArrivalInformationUICustomLayout.vue?vue&type=template&id=46997848&"
import script from "./tabArrivalInformationUICustomLayout.vue?vue&type=script&lang=js&"
export * from "./tabArrivalInformationUICustomLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46997848')) {
      api.createRecord('46997848', component.options)
    } else {
      api.reload('46997848', component.options)
    }
    module.hot.accept("./tabArrivalInformationUICustomLayout.vue?vue&type=template&id=46997848&", function () {
      api.rerender('46997848', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaImport/components/SiBooking/tabs/tabArrivalInformationUICustomLayout.vue"
export default component.exports